import { MEDIA_TYPES_LABEL } from 'components/MediaInput/MultimediaPlugin/types';

export const getMultiMediaListHeaderTitleText = (pluginType: string) => {
  switch (pluginType) {
    case MEDIA_TYPES_LABEL.ARTICLES:
      return 'LES DERNIERS ARTICLES PUBLIÉS';
    case MEDIA_TYPES_LABEL.RECIPES:
      return 'LES DERNIÈRES RECETTES PUBLIÉES';
    case MEDIA_TYPES_LABEL.SLIDESHOWS:
      return 'LES DERNIERS DIAPOS PUBLIÉS';
    case MEDIA_TYPES_LABEL.VIDEOS:
      return 'LES DERNIÈRES VIDÉOS PUBLIÉES';
    default:
      return '';
  }
};
